<!-- Floating Mihuru AI Avatar Widget Launcher (Bottom Left) -->
<div class="mihuru-ai-launcher-wrapper" *ngIf="!isOpen || isMinimized">
  <!-- Launcher Floating Button -->
  <button
    class="mihuru-ai-launcher-btn"
    [class.active-call]="isOpen && isMinimized"
    (click)="onLauncherClick($event)"
    [attr.aria-expanded]="isOpen && !isMinimized"
    aria-label="Mihuru AI Video Assistant"
    [title]="(isOpen && isMinimized) ? 'Click to resume Mihuru AI' : 'Talk to Mihuru AI Assistant'"
  >
    <!-- Normal idle pulse rings -->
    <div class="pulse-ring" *ngIf="!isOpen"></div>
    <div class="pulse-ring-outer" *ngIf="!isOpen"></div>

    <!-- Active Call glowing pulse rings -->
    <div class="pulse-ring-live" *ngIf="isOpen && isMinimized"></div>
    <div class="pulse-ring-live-outer" *ngIf="isOpen && isMinimized"></div>

    <div class="launcher-logo-container">
      <img
        src="assets/images/avatar_logo.svg"
        alt="Mihuru AI Avatar"
        class="launcher-logo-img"
      />
    </div>

    <!-- Online / Live status badge -->
    <span class="status-badge" [class.live-session]="isOpen && isMinimized" [title]="(isOpen && isMinimized) ? 'Call in progress' : 'AI Assistant Online'">
      <span class="status-dot"></span>
    </span>

    <!-- Close badge on the widget icon when minimized (Ends session directly) -->
    <button
      *ngIf="isOpen && isMinimized"
      class="launcher-close-badge"
      (click)="closeWidget($event)"
      title="Close & End AI Session"
      aria-label="Close & End AI Session"
    >
      <svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round">
        <line x1="18" y1="6" x2="6" y2="18"></line>
        <line x1="6" y1="6" x2="18" y2="18"></line>
      </svg>
    </button>
  </button>

  <!-- Interactive Text Bubble beside the AI Avatar Widget -->
  <div
    class="launcher-text-bubble"
    (click)="onLauncherClick($event)"
    role="button"
    tabindex="0"
    [title]="(isOpen && isMinimized) ? 'Click to resume Mihuru AI' : 'Talk to Mihuru AI Assistant'"
  >
    <span class="bubble-sparkle">✨</span>
    <span class="bubble-text">Talk to Mihuru AI Assistant</span>
    <span class="bubble-live-pill" *ngIf="isOpen && isMinimized">LIVE</span>
  </div>
</div>

<!-- Form-Like Widget Popup (Anchored at Bottom Left - Only shown when open and not minimized) -->
<div
  class="mihuru-ai-popup"
  *ngIf="isOpen && !isMinimized"
  role="dialog"
  aria-labelledby="aiWidgetTitle"
>
  <!-- Popup Header: Title + Minimize + Close Session -->
  <div class="popup-header">
    <div class="header-left">
      <div class="header-avatar-badge">
        <img src="assets/images/avatar_logo.svg" alt="Mihuru AI Avatar" class="header-logo" />
        <span class="header-live-dot"></span>
      </div>
      <div class="header-titles">
        <h4 id="aiWidgetTitle" class="widget-title">Mihuru AI Assistant</h4>
        <span class="widget-subtitle">
          <span class="live-pill">LIVE</span> Interactive Travel Advisor
        </span>
      </div>
    </div>

    <!-- Actions: Minimize and Close Session -->
    <div class="header-actions">
      <!-- Minimize Button (Minimizes to launcher icon) -->
      <button
        class="action-btn minimize-btn"
        (click)="minimizeWidget($event)"
        title="Minimize to icon"
        aria-label="Minimize"
      >
        <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor">
          <path d="M5 11h14v2H5z"/>
        </svg>
      </button>

      <!-- Close Session Button (Terminates call and closes popup) -->
      <button
        class="action-btn close-btn"
        (click)="closeWidget($event)"
        title="Close & End Session"
        aria-label="Close session"
      >
        <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
    </div>
  </div>

  <!-- Popup Body -->
  <div class="popup-body">

    <!-- State A: Permission Permanently Blocked Message -->
    <div class="body-permission-card blocked-card" *ngIf="permissionBlocked">
      <div class="permission-icon-box blocked-icon">
        <svg viewBox="0 0 24 24" width="38" height="38" fill="none" stroke="#ff4757" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="1" y1="1" x2="23" y2="23"></line>
          <path d="M9 9v3a3 3 0 0 0 5.12 2.12M15 9.34V4a3 3 0 0 0-5.94-.6"></path>
          <path d="M17 16.95A7 7 0 0 1 5 12v-2m14 0v2a7 7 0 0 1-.11 1.23"></path>
          <line x1="12" y1="19" x2="12" y2="23"></line>
          <line x1="8" y1="23" x2="16" y2="23"></line>
        </svg>
      </div>
      <h5 class="permission-title">Microphone Access Blocked</h5>
      <p class="permission-desc">
        Mihuru AI needs your microphone to hear your voice and reply in real time. Please unblock it in your browser:
      </p>
      <div class="permission-steps">
        <div class="step-row">
          <span class="step-num">1</span>
          <span class="step-text">Click the <strong>lock/tune icon (🔒)</strong> in your browser address bar.</span>
        </div>
        <div class="step-row">
          <span class="step-num">2</span>
          <span class="step-text">Change <strong>Microphone</strong> from Blocked to <strong>Allow</strong>.</span>
        </div>
        <div class="step-row">
          <span class="step-num">3</span>
          <span class="step-text">Click <strong>"I've Allowed It – Try Again"</strong> below.</span>
        </div>
      </div>
      <button class="permission-btn" (click)="requestPermissionAndStart()">
        <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round">
          <polyline points="1 4 1 10 7 10"></polyline>
          <path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"></path>
        </svg>
        I've Allowed It – Try Again
      </button>
    </div>

    <!-- State B: Permission Denied / Prompt Again -->
    <div class="body-permission-card" *ngIf="!permissionBlocked && permissionDenied">
      <div class="permission-icon-box">
        <svg viewBox="0 0 24 24" width="38" height="38" fill="none" stroke="#ffcc03" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"></path>
          <path d="M19 10v2a7 7 0 0 1-14 0v-2"></path>
          <line x1="12" y1="19" x2="12" y2="23"></line>
          <line x1="8" y1="23" x2="16" y2="23"></line>
        </svg>
      </div>
      <h5 class="permission-title">Microphone Access Required</h5>
      <p class="permission-desc">
        Please allow microphone access when prompted to speak directly with Mihuru AI.
      </p>
      <button class="permission-btn" (click)="requestPermissionAndStart()">
        <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor">
          <path d="M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3z"/>
        </svg>
        Allow Microphone & Start
      </button>
    </div>

    <!-- State C: Loading / Connecting State -->
    <div class="body-loading" *ngIf="!permissionBlocked && !permissionDenied && (isLoading || !isVideoReady)">
      <div class="avatar-ring-loader">
        <div class="ring-pulse"></div>
        <div class="ring-pulse-delay"></div>
        <div class="avatar-icon-box">
          <img src="assets/images/avatar_logo.svg" alt="Mihuru AI Avatar" class="pulse-avatar-img" />
        </div>
      </div>
      <h5 class="loading-title">Connecting to Mihuru AI...</h5>
      <p class="loading-subtext">
        Preparing your interactive session. Speak naturally to ask about credit lines, loans, and EMI plans!
      </p>
      <div class="loading-bars">
        <span class="bar bar-1"></span>
        <span class="bar bar-2"></span>
        <span class="bar bar-3"></span>
      </div>
    </div>

    <!-- State D: Connection Error -->
    <div class="body-error" *ngIf="!permissionBlocked && !permissionDenied && !isLoading && errorMessage">
      <div class="error-icon-box">
        <svg viewBox="0 0 24 24" width="36" height="36" fill="none" stroke="#ff4757" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="12" y1="8" x2="12" y2="12"></line>
          <line x1="12" y1="16" x2="12.01" y2="16"></line>
        </svg>
      </div>
      <h5 class="error-title">Connection Interrupted</h5>
      <p class="error-desc">{{ errorMessage }}</p>
      <button class="retry-btn" (click)="retry()">
        <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round">
          <polyline points="1 4 1 10 7 10"></polyline>
          <path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"></path>
        </svg>
        Retry Connection
      </button>
    </div>

    <!-- State E: Pure AI Avatar Video Container (Direct WebRTC Stream, Zero Meeting Chrome) -->
    <div class="avatar-video-wrapper" [class.ready]="isVideoReady">
      <video
        #avatarVideo
        autoplay
        playsinline
        webkit-playsinline
        class="avatar-video-element"
      ></video>
      <audio #avatarAudio autoplay></audio>

      <!-- Floating Voice Pill Overlay (Minimal Voice Mode indicator & Mute Toggle) -->
      <div class="floating-voice-pill" *ngIf="isVideoReady" (click)="toggleMute()">
        <div class="voice-indicator" [class.muted]="isMuted">
          <span class="wave wave-1" *ngIf="!isMuted"></span>
          <span class="wave wave-2" *ngIf="!isMuted"></span>
          <svg *ngIf="!isMuted" viewBox="0 0 24 24" width="14" height="14" fill="currentColor">
            <path d="M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3z"/>
            <path d="M17 11c0 2.76-2.24 5-5 5s-5-2.24-5-5H5c0 3.53 2.61 6.43 6 6.92V21h2v-3.08c3.39-.49 6-3.39 6-6.92h-2z"/>
          </svg>
          <svg *ngIf="isMuted" viewBox="0 0 24 24" width="14" height="14" fill="#ff4757">
            <line x1="1" y1="1" x2="23" y2="23" stroke="#ff4757" stroke-width="2.5"></line>
            <path d="M9 9v3a3 3 0 0 0 5.12 2.12M15 9.34V5c0-1.66-1.34-3-3-3s-3 1.34-3 3v4"></path>
          </svg>
        </div>
        <span class="voice-label">{{ isMuted ? 'Muted (Click to talk)' : 'Listening • Click to mute' }}</span>
      </div>
    </div>

  </div>
</div>
